"use client";

import { ArrowRight, Scale, ShieldCheck, FileText, Gavel, Award } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const disputeItems = [{
  number: "01",
  title: "BREACH OF CONTRACT",
  subtitle: "Commercial Litigation",
  description: "Resolving complex commercial disputes arising from vendor agreements, partnership disagreements, and non-compete covenants.",
  badge: "LITIGATION"
}, {
  number: "02",
  title: "PARTNERSHIP & SHAREHOLDER DISPUTES",
  subtitle: "Internal Corporate Conflicts",
  description: "Guiding businesses through fiduciary duty claims, minority shareholder oppression, buyout negotiations, and corporate dissolutions.",
  badge: "CORPORATE"
}, {
  number: "03",
  title: "REAL ESTATE LITIGATION",
  subtitle: "Property & Title Disputes",
  description: "Representing developers, commercial landlords, and investors in title defects, lease enforcement, and boundary disputes.",
  badge: "PROPERTY"
}, {
  number: "04",
  title: "EXPERT WITNESS IN ATTORNEY'S FEE HEARINGS",
  subtitle: "Fee Dispute Analysis",
  description: "Providing objective, authoritative testimony and analysis for attorney's fee hearings across South Florida courts.",
  badge: "EXPERT TESTIMONY"
}, {
  number: "05",
  title: "COMMERCIAL COLLECTIONS & LIENS",
  subtitle: "Asset Recovery",
  description: "Strategic enforcement of judgment liens, promissory notes, and commercial debt recovery for businesses and institutions.",
  badge: "RECOVERY"
}, {
  number: "06",
  title: "CORPORATE GOVERNANCE DISPUTES",
  subtitle: "Executive & Board Conflicts",
  description: "Representing officers, directors, and boards in internal governance challenges, voting rights disputes, and regulatory compliance issues.",
  badge: "GOVERNANCE"
}];
export default function Businessdisputeslist() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const card1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const card2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const card3 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const card4 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const card5 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const card6 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const refs = [card1, card2, card3, card4, card5, card6];
  return <section className="py-24 bg-background text-foreground relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={header.ref} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-secondary/10 text-primary text-xs font-semibold tracking-wider uppercase mb-4">
            <Scale className="size-3.5" />
            Areas of Focus
          </div>
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-primary mb-6">
            Selective Business Litigation & Dispute Resolution
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg">
            Providing rigorous legal advocacy and counsel for high-stakes commercial, corporate, and real estate controversies across South Florida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {disputeItems.map((item, index) => {
          const currentRef = refs[index];
          return <div key={index} data-index={index} ref={currentRef.ref} className={`bg-card rounded-lg p-8 shadow border border-border flex flex-col justify-between transition-all duration-700 hover:shadow-md ${currentRef.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <div>
                  <div className="flex items-center justify-between mb-6">
                    <span className="text-4xl font-serif font-bold text-secondary">{item.number}</span>
                    <span className="text-[10px] tracking-wider font-semibold px-2.5 py-1 rounded-md bg-accent text-primary uppercase">
                      {item.badge}
                    </span>
                  </div>
                  <div className="text-xs font-semibold text-muted-foreground tracking-wider uppercase mb-1">
                    {item.subtitle}
                  </div>
                  <h3 className="text-xl font-serif font-bold text-primary mb-4">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-6">
                    {item.description}
                  </p>
                </div>
                <div className="pt-4 border-t border-border flex items-center justify-between">
                  <Link to="/ContactUsPage" className="inline-flex items-center gap-2 text-xs font-semibold text-primary hover:text-secondary transition-colors">
                    <span>Discuss Matter</span>
                    <ArrowRight className="size-3.5" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}